import React from "react";
import PropTypes from "prop-types";

const ProtectedComponent = (props) => {
  const session = localStorage.getItem("session");
  const sessionObj = session && JSON.parse(session);
  const loggedInUser = localStorage.getItem("loggedInUser");
  const loggedInUserObj = loggedInUser && JSON.parse(loggedInUser);

  if (!sessionObj) {
    return null;
  }

  if (sessionObj && !loggedInUserObj && props.roles) {
    return null;
  }

  if (
    sessionObj &&
    loggedInUserObj &&
    props.roles &&
    props.roles.indexOf(loggedInUserObj.role) === -1
  ) {
    return null;
  }

  return <>{props.children}</>;
};

ProtectedComponent.propTypes = {
  roles: PropTypes.array,
};

export default ProtectedComponent;
